export const transitionSpeed = '500ms';
